"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var DynaNodeMessage_1 = require("../DynaNodeMessage/DynaNodeMessage");
var unknownError_1 = require("../utils/unknownError");
var defaultSettings_1 = require("../defaultSettings");
var DynaNodeWSConnection = /** @class */ (function () {
    function DynaNodeWSConnection(config) {
        var _this = this;
        this.config = config;
        this.sendMessageJobs = [];
        this.closeJobs = [];
        this.config.engineIOSocket.on('message', function (data) { return _this.handleMessage(data); });
        this.config.engineIOSocket.on('close', function (serverAddress) { return _this.handleConnectionClose(serverAddress); });
    }
    Object.defineProperty(DynaNodeWSConnection.prototype, "serverAddress", {
        get: function () {
            return this.config.serverAddress;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeWSConnection.prototype.send = function (message, compress) {
        var _this = this;
        if (compress === void 0) { compress = true; }
        return new Promise(function (resolve, reject) {
            message._addTrace('DynaNode/ClientWSConnection/SEND_003', "DynaNode: DynaNodeClient WS connection pushing to internal queue");
            _this.sendMessageJobs.push({
                message: message, compress: compress,
                resolve: resolve, reject: reject,
            });
            if (_this.sendMessageJobs.length === 1) {
                _this.sendNext();
            }
        });
    };
    DynaNodeWSConnection.prototype.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.closeJobs.push(resolve);
                        _this.config.engineIOSocket.close();
                    })];
            });
        });
    };
    DynaNodeWSConnection.prototype.sendNext = function () {
        var _this = this;
        var sendMessageJob = this.sendMessageJobs.shift();
        if (!sendMessageJob)
            return;
        var message = sendMessageJob.message, compress = sendMessageJob.compress, resolve = sendMessageJob.resolve, reject = sendMessageJob.reject;
        try {
            message._addTrace("DynaNode/ClientWSConnection/SEND_004 (client's last step)", "DynaNode: DynaNodeClient WS connection pushing to network layer");
            var packMessage = message.pack();
            if (!packMessage.validPacketSize) {
                throw {
                    code: 202011040819,
                    message: "Message exceeds the max packet size: " + (message.headers.dynaMaxPacketSizeProtection || defaultSettings_1.DEFAULT_maxMessagePacketSize),
                    data: {
                        message: message.viewSecure,
                        messagePacketSize: packMessage.packet.length,
                        maxPacketSizeRestrictionCameFrom: message.headers.dynaMaxPacketSizeProtection
                            ? "Message's dynaMaxPacketSizeProtection header"
                            : "dyna-node's default setting",
                    },
                };
            }
            this.config.engineIOSocket.send(packMessage.packet, { compress: compress }, function () {
                resolve(message);
                _this.sendNext();
            });
        }
        catch (error) {
            reject(error || unknownError_1.unknownError(1810191207, 'DynaNodeWSConnection/send'));
        }
    };
    DynaNodeWSConnection.prototype.handleMessage = function (data) {
        var message = new DynaNodeMessage_1.DynaNodeMessage();
        var parseResult = message.unPack(data);
        if (parseResult.success) {
            message._addTrace('DynaNode/ClientWSConnection/RECEIVE_001', "DynaNode: WSConnection, incoming message from server " + this.config.serverAddress);
            this.config.onMessage(message);
        }
        else {
            this.config.onError({
                section: 'DynaNodeConnection(client)/handleMessage',
                code: 11552307,
                message: 'on message event, incoming data cannot be parsed as message',
                data: {
                    incomingData: data,
                    connection: this,
                    parseError: parseResult.error,
                },
            });
        }
    };
    DynaNodeWSConnection.prototype.handleConnectionClose = function (serverAddress) {
        while (this.closeJobs.length) {
            var job = this.closeJobs.shift();
            if (job)
                job(serverAddress);
        }
        this.config.onConnectionClose(serverAddress);
    };
    DynaNodeWSConnection.prototype._debug_dropConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.disconnect()];
                    case 1:
                        _a.sent();
                        this.config.onConnectionClose("*violent*disconnect*");
                        return [2 /*return*/];
                }
            });
        });
    };
    return DynaNodeWSConnection;
}());
exports.DynaNodeWSConnection = DynaNodeWSConnection;
//# sourceMappingURL=DynaNodeWSConnection.js.map